import { createContext, useContext } from "react";
import { usePathDefinition } from "@edreamsodigeo/frontend-router";

export type PathDefinitionHook = () => string | undefined;

const useServerFakePathDefinition = () => "";

export const UsePathDefinitionContext = createContext<PathDefinitionHook>(
  typeof window === "undefined"
    ? useServerFakePathDefinition
    : usePathDefinition,
);

export const usePathDefinitionFromContext: PathDefinitionHook = () => {
  const usePathDefinitionHook = useContext(UsePathDefinitionContext);

  return usePathDefinitionHook();
};
